import { schemas } from "@card-data/generated/api.client";
import { CreditCardInput } from "@card-data/types";
import { WEIGHTS } from "@card-data/weights";

export const IHG_CARDS: Array<CreditCardInput> = [
  {
    cardId: "40192e08e31f059d91a108ff09ec5dd5",
    name: "IHG Premier",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.IHG,
    isBusiness: false,
    annualFee: 99,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/ihg-rewards-club/premier",
    imageUrl: "/images/chase/ihg-rewards-premier.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 180_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        details:
          "180k after $3k/90d; additional 10k available after adding an authorized user within 3 months.",
        expiration: "2026-11-18",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 185_000 }],
        spend: 6000,
        days: 180,
        credits: [],
        details: "150k @ $3k/90d, +35k @ $6k total/180d.",
        expiration: "2026-09-30",
      },
      {
        amount: [{ amount: 150_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        details: "150k @ $3k/90d, +35k @ $6k total/180d.",
        expiration: "2026-09-30",
      },
      {
        amount: [{ amount: 140_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-06-07",
      },
      {
        amount: [{ amount: 175_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-03-18",
      },
      {
        amount: [{ amount: 175_000 }],
        spend: 4000,
        days: 90,
        credits: [
          {
            value: 400,
            description: "FNC worth up to 40k points.",
            currency: schemas.CurrenciesEnum.enum.IHG,
            weight: WEIGHTS.FREE_NIGHT_CREDIT,
          },
        ],
        url: "https://www.ihg.com/onerewards/content/us/en/creditcard",
      },
      {
        amount: [{ amount: 175_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "bc82fb7022c639f90b9378410127b9e6",
    name: "IHG Premier Business",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.IHG,
    isBusiness: true,
    annualFee: 99,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/business-credit-cards/IHG/business-premier",
    imageUrl: "/images/chase/ihg-rewards-premier-business.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 190_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        details: "190k after $5k/90d.",
        expiration: "2026-11-18",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200_000 }],
        spend: 9000,
        days: 90,
        credits: [],
        details: "140k @ $4k, +60k @ $9k.",
        expiration: "2026-09-30",
      },
      {
        amount: [{ amount: 140_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        details: "140k @ $4k, +60k @ $9k.",
        expiration: "2026-09-30",
      },
      {
        amount: [{ amount: 175_000 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "2c6c7e215b4a1e791250d1fb48997e02",
    name: "IHG Traveler",
    issuer: schemas.IssuersEnum.enum.CHASE,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.IHG,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.chase.com/travel-credit-cards/ihg-rewards-club/traveler",
    imageUrl: "/images/chase/ihg-rewards-traveler.jpeg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 125_000 }],
        spend: 2000,
        days: 90,
        credits: [],
        details: "125k after $2k/90d.",
        expiration: "2026-11-18",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 125_000 }],
        spend: 4000,
        days: 180,
        credits: [],
        details: "90k @ $2k/90d, +35k @ $4k total/180d.",
        expiration: "2026-09-30",
      },
      {
        amount: [{ amount: 90_000 }],
        spend: 2000,
        days: 90,
        credits: [],
        details: "90k @ $2k/90d, +35k @ $4k total/180d.",
        expiration: "2026-09-30",
      },
      {
        amount: [{ amount: 80_000 }],
        spend: 2000,
        days: 90,
        credits: [],
        expiration: "2026-06-07",
      },
      {
        amount: [{ amount: 90_000 }],
        spend: 2000,
        days: 90,
        credits: [],
        details: "40k + 2x FNC (<= 50k per).",
        expiration: "2026-05-03",
      },
      {
        amount: [{ amount: 120_000 }],
        spend: 2000,
        days: 90,
        credits: [],
      },
    ],
  },
];
